import { useCallback, useEffect, useState } from "react";

import type { HaulerRoutesResponse } from "@/lib/logistics/haulerTypes";
import { fetchHaulerRoutes } from "@/lib/logistics/haulerClient";
import {
  readHaulerScopedCarrierIdFromStorage,
  writeHaulerScopedCarrierIdToStorage,
} from "@/lib/roles/haulerAccess";
import { useAuth } from "@/contexts/AuthContext";

export function useHaulerApp() {
  const auth = useAuth();
  const [payload, setPayload] = useState<HaulerRoutesResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [carrierScopeInput, setCarrierScopeInput] = useState(
    () => readHaulerScopedCarrierIdFromStorage() ?? ""
  );

  const isPlatform =
    auth.status === "ready" &&
    auth.hasRole("platform_owner", "platform_admin", "platform_dev");

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    if (isPlatform && carrierScopeInput.trim()) {
      writeHaulerScopedCarrierIdToStorage(carrierScopeInput.trim());
    }
    const res = await fetchHaulerRoutes();
    if (!res.ok) {
      setError(res.error);
      setPayload(null);
    } else {
      setPayload(res.data);
    }
    setLoading(false);
  }, [carrierScopeInput, isPlatform]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    payload,
    loading,
    error,
    refresh,
    isPlatform,
    carrierScopeInput,
    setCarrierScopeInput,
  };
}
